import { createFileRoute, redirect } from '@tanstack/react-router';

// The Brand Deal Arena is Operations' Deals view since 10 Oct 2026: an old link lands there with everything it carried
// (All deals or Focus view, the deal it picked), on every campaign at once, so the deal it named is always there.
export const Route = createFileRoute('/_authed/brand-deals')({
  beforeLoad: ({ location }) => {
    throw redirect({ to: '/operations/deals', search: location.search as Record<string, never>, replace: true });
  },
});
